import React from "react";
import { toast } from "react-toastify";
import { Typeahead } from "react-bootstrap-typeahead";
import { CommandBarButton } from "@fluentui/react";
import {
  Button,
  Checkbox,
  MessageBar,
  MessageBarActions,
  MessageBarBody,
  MessageBarTitle,
} from "@fluentui/react-components";
import { SearchBox } from "@fluentui/react/lib/SearchBox";
import { DismissRegular } from "@fluentui/react-icons";
import {
  addFileStep3,
  getFileListDeptWise,
  getfilesByFileName,
  getFileSheetType,
} from "../../actions/FileAction";
import { getDepartmentList } from "../../actions/MasterAction";
import { getCookie, setCookie } from "../../utils";
import CONSTANT from "../../constant";
import { fileOtpVerify, FileSendOpt } from "../../actions/AuthAction";
import Swal from "sweetalert2";
import constant from "../../constant";
import { withRouter } from "react-router-dom";

class ReferencesStep3 extends React.Component {
  constructor(props) {
    const userDetail = getCookie(CONSTANT.cookie.userDetail);
    super(props);
    const initialData = props.initialData || {};

    this.state = {
      userDetail,
      department: {
        name: "department",
        value: initialData.department || [],
        error: "",
        isRequired: false,
        options: props.departmentOptions || [],
      },
      referenceFilesDept: {
        name: "referenceFilesDept",
        value: initialData.referenceFilesDept || [],
        error: "",
        options: props.referenceFilesDeptOptions || [],
      },
      referenceFiles: {
        name: "referenceFiles",
        value: initialData.referenceFiles || [],
        error: "",
        options: props.referenceFilesOptions || [],
      },
      parkedFile: {
        name: "parkedFile",
        value: initialData.parkedFile || [],
        error: "",
        options: props.parkedFileOptions || [],
      },
      showParsedFile: false,
      showParkedFileTimelineStatus: false,
      notifyEmail: initialData.notifyEmail || false,
      notifySMS: initialData.notifySMS || false,
      showLoader: false,
      isLoadingFiles: false,
      sheetType: null,
      isLoadingSheetType: true,
    };
  }

  async componentDidMount() {
    try {
      // Fetch department list
      const deptRes = await getDepartmentList();

      this.setState((prevState) => ({
        department: {
          ...prevState.department,
          options: deptRes.result || [],
        },
        referenceFilesDept: {
          ...prevState.referenceFilesDept,
          options: deptRes.result || [],
        },
      }));
    } catch (error) {
      console.error("Error loading departments:", error);
      toast.error("Failed to load department list");
    }

    // Fetch sheet type
    this.fetchSheetType();
  }

  // Fetch sheet type
  fetchSheetType = async () => {
    const fileCode = this.props.fileCode;

    if (!fileCode) {
      this.setState({ isLoadingSheetType: false });
      return;
    }

    try {
      this.setState({ isLoadingSheetType: true });
      const response = await getFileSheetType(fileCode);

      if (response.status === "success") {
        this.setState({
          sheetType: response.result.sheetType,
          isLoadingSheetType: false,
        });
      } else {
        console.error("Failed to fetch sheet type:", response.error);
        this.setState({ isLoadingSheetType: false });
      }
    } catch (error) {
      console.error("Error fetching sheet type:", error);
      this.setState({ isLoadingSheetType: false });
    }
  };

  componentDidUpdate(prevProps) {
    // Handle initialData changes
    if (
      this.props.initialData !== prevProps.initialData &&
      this.props.initialData
    ) {
      const initialData = this.props.initialData;
      this.setState((prevState) => ({
        referenceFilesDept: {
          ...prevState.referenceFilesDept,
          value: initialData.referenceFilesDept || [],
        },
        referenceFiles: {
          ...prevState.referenceFiles,
          value: initialData.referenceFiles || [],
        },
        parkedFile: {
          ...prevState.parkedFile,
          value: initialData.parkedFile || [],
        },
        notifyEmail: initialData.notifyEmail || false,
        notifySMS: initialData.notifySMS || false,
      }));
    }
  }

  // Helper function to set options
  setOptions = (component, fieldName, options) => {
    component.setState((prevState) => ({
      [fieldName]: {
        ...prevState[fieldName],
        options: options || [],
      },
    }));
  };

  // MenuListWithNestedSubmenus function for parked files
  MenuListWithNestedSubmenus = (options) => {
    return options.map((item, index) => (
      <div
        key={index}
        className="form-check mb-2 px-4 py-2"
        style={{
          borderBottom: index < options.length - 1 ? "1px solid #eee" : "none",
          backgroundColor: this.state.parkedFile.value.some(
            (f) => f.code === item.code
          )
            ? "#e6f7ff"
            : "transparent",
        }}
      >
        <input
          type="checkbox"
          className="form-check-input"
          id={`parked-file-${index}`}
          checked={this.state.parkedFile.value.some(
            (f) => f.code === item.code
          )}
          onChange={(e) => this.handleParkedFileSelect(item, e.target.checked)}
        />
        <label
          className="form-check-label ms-2"
          htmlFor={`parked-file-${index}`}
        >
          <div>
            <strong>{item.fileNumber || item.code}</strong> -{" "}
            {item.originalFileName || item.name}
          </div>
          {item.subject && (
            <div className="text-muted small" style={{ fontSize: "0.85rem" }}>
              Subject: {item.subject}
            </div>
          )}
          {item.dated && (
            <div className="text-muted small" style={{ fontSize: "0.85rem" }}>
              Date: {new Date(item.dated).toLocaleDateString()}
            </div>
          )}
        </label>
      </div>
    ));
  };

  // Handle parked file selection
  handleParkedFileSelect = (file, isChecked) => {
    this.setState((prevState) => {
      const currentFiles = [...prevState.parkedFile.value];

      if (isChecked) {
        // Add file if not already selected
        if (!currentFiles.some((f) => f.code === file.code)) {
          currentFiles.push(file);
        }
      } else {
        // Remove file
        const index = currentFiles.findIndex((f) => f.code === file.code);
        if (index > -1) {
          currentFiles.splice(index, 1);
        }
      }

      return {
        parkedFile: {
          ...prevState.parkedFile,
          value: currentFiles,
        },
      };
    });
  };

  // Handle department selection for references
  handleDeptSelect = async (selected) => {
    if (!selected || selected.length === 0) {
      this.setState((prevState) => ({
        referenceFilesDept: {
          ...prevState.referenceFilesDept,
          value: [],
        },
        referenceFiles: {
          ...prevState.referenceFiles,
          options: [],
          value: [],
        },
      }));
      return;
    }

    this.setState((prevState) => ({
      referenceFilesDept: {
        ...prevState.referenceFilesDept,
        value: selected,
      },
      referenceFiles: {
        ...prevState.referenceFiles,
        options: [],
        value: [],
      },
    }));

    try {
      this.setState({ isLoadingFiles: true });
      const deptCode = selected[0].code;
      const fileList = await getFileListDeptWise(deptCode);

      this.setState((prevState) => ({
        referenceFiles: {
          ...prevState.referenceFiles,
          options: fileList.result || [],
        },
        isLoadingFiles: false,
      }));

      if (!fileList.result || fileList.result.length === 0) {
        toast.info("No files found for this department");
      }
    } catch (error) {
      console.error("Error loading reference files:", error);
      toast.error("Error loading files for selected department");
      this.setState({ isLoadingFiles: false });
    }
  };

  // Handle reference file selection
  handleFileSelect = (file, isChecked) => {
    this.setState((prevState) => {
      const currentFiles = [...prevState.referenceFiles.value];

      if (isChecked) {
        if (!currentFiles.some((f) => f.fileCode === file.fileCode)) {
          currentFiles.push(file);
        }
      } else {
        const index = currentFiles.findIndex(
          (f) => f.fileCode === file.fileCode
        );
        if (index > -1) {
          currentFiles.splice(index, 1);
        }
      }

      return {
        referenceFiles: {
          ...prevState.referenceFiles,
          value: currentFiles,
        },
      };
    });
  };

  // Handle search for reference files
  handleSearch = async (searchValue) => {
    if (!searchValue.trim()) {
      const { referenceFilesDept } = this.state;
      if (referenceFilesDept.value.length > 0) {
        this.handleDeptSelect(referenceFilesDept.value);
      }
      return;
    }

    try {
      this.setState({ showLoader: true });

      const { referenceFiles } = this.state;
      const filteredFiles = referenceFiles.options.filter(
        (file) =>
          file.fileNumber?.toString().includes(searchValue) ||
          file.originalFileName
            ?.toLowerCase()
            .includes(searchValue.toLowerCase()) ||
          file.subject?.toLowerCase().includes(searchValue.toLowerCase())
      );

      this.setState((prevState) => ({
        referenceFiles: {
          ...prevState.referenceFiles,
          options: filteredFiles,
        },
      }));
    } catch (error) {
      console.error("Error searching files:", error);
      toast.error("Error searching files");
    } finally {
      this.setState({ showLoader: false });
    }
  };

  verifyOTP = async (mobile, OptMOdel) => {
    const otpResponse = await FileSendOpt(OptMOdel);
    if (otpResponse.status === "failed") {
      Swal.fire({
        icon: "error",
        text: otpResponse?.error,
      });
      this.setState({ showLoader: false, showModal: false });
      return false;
    }

    let isOTPVerified = false;

    while (!isOTPVerified) {
      const { value: otp, isDismissed } = await Swal.fire({
        title: "OTP Verification",
        html: `
        <div>
          <p style="text-align:center; padding:0 20px;">
            OTP verification is mandatory. Enter the OTP sent to your mobile.
          </p>
          <input
            id="otp-input"
            class="swal2-input"
            placeholder="Enter OTP"
            type="number"
            maxlength="6"
            style="width: 80%; margin: 10px auto; letter-spacing: 2px; font-size: 20px; display:block;"
            oninput="this.value = this.value.replace(/[^0-9]/g,'').slice(0,6)"
          />
          <button id="resend-otp-btn">Sending...</button>
        </div>
      `,
        icon: "info",
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: "Verify",
        cancelButtonText: "Cancel",
        allowOutsideClick: false,
        allowEscapeKey: false,
        preConfirm: () => {
          const otpInput = document.getElementById("otp-input");
          const otp = otpInput.value.trim();
          if (!otp) Swal.showValidationMessage("Please enter OTP");
          else if (otp.length !== 6)
            Swal.showValidationMessage("OTP must be 6 digits");
          else return otp;
        },
        didOpen: () => {
          const input = document.getElementById("otp-input");
          input.focus();
          const resendBtn = document.getElementById("resend-otp-btn");
          if (resendBtn) {
            let countdown = 60;
            const countdownInterval = setInterval(() => {
              countdown--;
              resendBtn.setAttribute("disabled", "true");
              resendBtn.textContent = `Resend OTP in ${countdown}s`;
              if (countdown <= 0) {
                clearInterval(countdownInterval);
                resendBtn.removeAttribute("disabled");
                resendBtn.textContent = "Resend OTP";
              }
            }, 1000);

            resendBtn.addEventListener("click", async () => {
              resendBtn.setAttribute("disabled", "true");
              resendBtn.textContent = "Resending...";
              try {
                await FileSendOpt(OptMOdel);
                resendBtn.textContent = "OTP Resent ✔️";
              } catch (error) {
                resendBtn.textContent = "Failed. Try Again";
              }
              let countdown = 60;
              const countdownInterval = setInterval(() => {
                countdown--;
                resendBtn.textContent = `Resend OTP in ${countdown}s`;
                if (countdown <= 0) {
                  clearInterval(countdownInterval);
                  resendBtn.removeAttribute("disabled");
                  resendBtn.textContent = "Resend OTP";
                }
              }, 1000);
            });
          }
        },
      });

      if (isDismissed) {
        this.setState({ showLoader: false });
        return false;
      }

      if (otp) {
        this.setState({ showLoader: true });
        try {
          const verifyOptmOdel = { mobile, mob_otp: otp };
          const verificationResult = await fileOtpVerify(verifyOptmOdel);
          if (verificationResult.status === "success") {
            toast.success("OTP verified successfully!");
            setCookie(CONSTANT.cookie.token, verificationResult.result.token);
            setCookie(
              CONSTANT.cookie.userDetail,
              verificationResult.result.userDetail
            );
            isOTPVerified = true;
          } else {
            toast.error("Invalid OTP. Please try again.");
            this.setState({ showLoader: false });
          }
        } catch (error) {
          toast.error("Failed to verify OTP. Please try again.");
          this.setState({ showLoader: false });
        }
      }
    }

    return true;
  };

  // Handle step completion
  handleComplete = async (saveAsDraft) => {
    const { notifyEmail, notifySMS, referenceFiles, parkedFile, mobile } =
      this.state;
    const { fileCode } = this.props;

    if (!fileCode) {
      toast.error("File code is missing. Please go back to step 1.");
      return;
    }

    // If not saving as draft, verify OTP first
    if (!saveAsDraft) {
      let { mobile } = this.state.userDetail;
      let OptMOdel = { mobile };
      const otpVerified = await this.verifyOTP(mobile, OptMOdel);
      if (!otpVerified) {
        // Stop execution if OTP verification fails or user cancels
        return;
      }
    }

    this.setState({ showLoader: true });

    const stepData = {
      referenceFiles: referenceFiles.value,
      parkedFileReference: parkedFile.value,
      notifyEmail,
      notifySMS,
      saveAsDraft,
    };

    try {
      const res = await addFileStep3(fileCode, stepData);

      // Prepare the data to pass to parent
      const stepData2 = {
        referenceFiles: referenceFiles.value,
        parkedFile: parkedFile.value,
        notifyEmail,
        notifySMS,
        saveAsDraft,
      };

      this.props.onStepComplete(stepData2);
      if (!saveAsDraft) {
        this.props.history.push(constant.component.myFiles.url);
      } else {
        this.props.history.push(constant.component.DraftList.url);
      }
    } catch (error) {
      console.error("Error completing step:", error);
      toast.error("Failed to complete step. Please try again.");
    } finally {
      this.setState({ showLoader: false });
    }
  };

  render() {
    const {
      referenceFilesDept,
      referenceFiles,
      parkedFile,
      showParsedFile,
      notifyEmail,
      notifySMS,
      showLoader,
      isLoadingFiles,
      sheetType,
      isLoadingSheetType,
    } = this.state;

    // Determine if Submit File button should be shown
    const showSubmitButton = !isLoadingSheetType && sheetType !== "yellow";

    return (
      <div className="step-content">
        <h5 className="mb-2 fw-semibold">Step 3: References & Notifications</h5>
        {console.log("parkedFileAttached", parkedFile)}
        <div className="row">
          <div className="col-md-12">
            {/* Parked Files Section */}
            <div className="card mb-2">
              <div className="card-body pt-2">
                <h6 className="card-title mb-1 fw-medium">Parked Files</h6>

                <div className="form-group mb-0">
                  <label>
                    Attach Parked Files <small>(Optional)</small>
                  </label>
                  {parkedFile.value.length > 0 && (
                    <CommandBarButton
                      onClick={() =>
                        this.setState({
                          showParkedFileTimelineStatus: true,
                        })
                      }
                      style={{
                        backgroundColor: "transparent",
                        color: "blue",
                        float: "right",
                      }}
                      text="Parked File Status"
                    />
                  )}

                  <div className="mt-2">
                    <SearchBox
                      placeholder="Search files by name"
                      onFocus={() => {
                        this.setState({
                          showParsedFile: true,
                        });
                      }}
                      onChange={(e) => {
                        const inputVal = e.target.value;
                        if (inputVal.trim()) {
                          getfilesByFileName(inputVal)
                            .then((response) => {
                              this.setState((prevState) => ({
                                parkedFile: {
                                  ...prevState.parkedFile,
                                  options: response.result || [],
                                },
                              }));
                            })
                            .catch((error) => {
                              console.error(
                                "Error searching parked files:",
                                error
                              );
                            });
                        }
                      }}
                    />
                  </div>

                  {showParsedFile && parkedFile.options.length > 0 ? (
                    <div
                      className="mt-2"
                      style={{
                        maxHeight: "30vh",
                        overflowY: "scroll",
                      }}
                    >
                      {this.MenuListWithNestedSubmenus(parkedFile.options)}
                    </div>
                  ) : showParsedFile ? (
                    <div className="mt-2">
                      <MessageBar>
                        <MessageBarBody>
                          <MessageBarTitle>
                            No search results Found
                          </MessageBarTitle>
                        </MessageBarBody>
                        <MessageBarActions
                          containerAction={
                            <Button
                              appearance="transparent"
                              icon={<DismissRegular />}
                              onClick={() =>
                                this.setState({ showParsedFile: false })
                              }
                            />
                          }
                        />
                      </MessageBar>
                    </div>
                  ) : null}
                </div>

                {parkedFile.value.length > 0 && (
                  <div className="mt-3 alert alert-info">
                    <small>
                      <strong>
                        Selected Parked Files: {parkedFile.value.length} file(s)
                      </strong>
                      <ul className="mb-0 mt-1">
                        {parkedFile.value.map((file, index) => (
                          <li key={index}>
                            {file.fileNumber || file.code} -{" "}
                            {file.originalFileName || file.name}
                          </li>
                        ))}
                      </ul>
                    </small>
                  </div>
                )}
              </div>
            </div>

            {/* Reference Files Section */}
            <div className="card mb-2">
              <div className="card-body pt-2">
                <h6 className="card-title mb-1 fw-medium">Add References</h6>

                <div className="form-group mb-0">
                  <label>
                    Select Department <small>(Optional)</small>
                  </label>
                  <Typeahead
                    id="ta-reference-dept"
                    labelKey="name"
                    options={referenceFilesDept.options}
                    selected={referenceFilesDept.value}
                    onChange={this.handleDeptSelect}
                    placeholder="Select department to view files"
                    isLoading={showLoader}
                  />
                  <small className="text-muted">
                    Select a department to view available files for reference
                  </small>
                </div>

                {isLoadingFiles && (
                  <div className="text-center my-3">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2">Loading files...</p>
                  </div>
                )}

                {!isLoadingFiles && referenceFiles.options.length > 0 && (
                  <div className="form-group">
                    <label>
                      Select Reference Files <small>(Optional)</small>
                    </label>
                    <div className="mb-3">
                      <SearchBox
                        placeholder="Search files by number, name or subject"
                        onSearch={this.handleSearch}
                        className="mb-2"
                        styles={{
                          root: {
                            width: "100%",
                            maxWidth: "400px",
                          },
                        }}
                      />
                      <small className="text-muted d-block">
                        {referenceFiles.options.length} files found
                      </small>
                    </div>

                    <div
                      className="reference-files-list"
                      style={{
                        maxHeight: "300px",
                        overflowY: "auto",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        padding: "0px 25px",
                      }}
                    >
                      {referenceFiles.options.map((file, index) => (
                        <div
                          key={index}
                          className="form-check mb-2 px-3 py-2"
                          style={{
                            borderBottom:
                              index < referenceFiles.options.length - 1
                                ? "1px solid #eee"
                                : "none",
                          }}
                        >
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`ref-file-${index}`}
                            checked={referenceFiles.value.some(
                              (f) => f.fileCode === file.fileCode
                            )}
                            onChange={(e) =>
                              this.handleFileSelect(file, e.target.checked)
                            }
                          />
                          <label
                            className="form-check-label ms-2"
                            htmlFor={`ref-file-${index}`}
                          >
                            <div>
                              <strong>{file.fileNumber}</strong> -{" "}
                              {file.originalFileName}
                            </div>
                            {file.subject && (
                              <div
                                className="text-muted small"
                                style={{ fontSize: "0.85rem" }}
                              >
                                Subject: {file.subject}
                              </div>
                            )}
                            <div
                              className="text-muted small"
                              style={{ fontSize: "0.85rem" }}
                            >
                              Created:{" "}
                              {new Date(file.createdAt).toLocaleDateString()}
                            </div>
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {referenceFiles.value.length > 0 && (
                  <div className="mt-3 alert alert-info">
                    <small>
                      <strong>
                        Selected: {referenceFiles.value.length} file(s)
                      </strong>
                      <ul className="mb-0 mt-1">
                        {referenceFiles.value.map((file, index) => (
                          <li key={index}>
                            {file.fileNumber} - {file.originalFileName}
                          </li>
                        ))}
                      </ul>
                    </small>
                  </div>
                )}

                {!isLoadingFiles &&
                  referenceFilesDept.value.length > 0 &&
                  referenceFiles.options.length === 0 && (
                    <div className="alert alert-warning">
                      No files found for department:{" "}
                      <strong>{referenceFilesDept.value[0].name}</strong>
                    </div>
                  )}
              </div>
            </div>

            {/* Notifications Section */}
            <div className="card mb-2">
              <div className="card-body pt-2">
                <h6 className="card-title mb-1 fw-medium">Priority Notification</h6>
                <div className="d-flex gap-4">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="notifyEmail"
                      checked={notifyEmail}
                      onChange={(e) =>
                        this.setState({ notifyEmail: e.target.checked })
                      }
                    />
                    <label className="form-check-label" htmlFor="notifyEmail">
                      Email
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="notifySMS"
                      checked={notifySMS}
                      onChange={(e) =>
                        this.setState({ notifySMS: e.target.checked })
                      }
                    />
                    <label className="form-check-label" htmlFor="notifySMS">
                      SMS
                    </label>
                  </div>
                </div>
                <small className="text-muted d-block mt-1">
                  Receive notifications when this file is processed
                </small>
              </div>
            </div>

            {/* Navigation Buttons */}
            <div className="mt-4">
              <div className="d-flex justify-content-between">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={this.props.onPrevStep}
                  disabled={showLoader || isLoadingFiles}
                >
                  Previous
                </button>
                <div>
                  <button
                    type="button"
                    className="btn btn-outline-secondary me-2"
                    onClick={() => this.handleComplete(true)}
                    disabled={showLoader || isLoadingFiles}
                  >
                    Save as Draft
                  </button>
                  {showSubmitButton && (
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => this.handleComplete(false)}
                      disabled={showLoader || isLoadingFiles || isLoadingSheetType}
                    >
                      {showLoader ? "Processing..." : "Submit File"}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ReferencesStep3);